/**
 * Formats the expiry date to MM/YY format
 * @param {number} expiryMonth - The expiry month
 * @param {number} expiryYear - The expiry year
 * @returns {string} Formatted expiry date or 'N/A' if invalid
 */
export const formatExpiryDate = (expiryMonth, expiryYear) => {
  if (!expiryMonth || !expiryYear) {
    return 'N/A';
  }
  const month = expiryMonth.toString().padStart(2, '0');
  const year = expiryYear.toString().slice(-2);
  return `${month}/${year}`;
};

/**
 * Formats the card number to show only last 4 digits
 * @param {string} last4 - Last 4 digits of the card
 * @returns {string} Formatted card number or 'N/A' if invalid
 */
export const formatCardNumber = (last4) => {
  if (!last4) {
    return 'N/A';
  }
  return `***${last4}`;
};

export const SUBSCRIPTION_STATUSES = {
  ACTIVE: 'active',
  CANCELLED: 'cancelled',
};
